// import { combineReducers } from 'redux';
import { GET_CUSTOMER_STATUS_FAULT_SUCCESS, GET_CUSTOMER_STATUS_FAULT_FAILED, GET_CUSTOMER_FAULT_IMAGE_SUCCESS } from '../actions/types';

const initialState = {
    customerStationFaults: [],
    customerFaultImageUrl: '',
    stationList: []
}

const CustomerStationFaultsReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_CUSTOMER_STATUS_FAULT_SUCCESS:
            return {
                ...state,
                customerStationFaults: action.response.body,
                stationList: action.response.body.station_list
            }

        case GET_CUSTOMER_STATUS_FAULT_FAILED:
            return {
                ...state,
                customerStationFaults: []
            }

        case GET_CUSTOMER_FAULT_IMAGE_SUCCESS:
            return {
                ...state,
                customerFaultImageUrl: action.response
            }

        default:
            return state
    }
}

export default CustomerStationFaultsReducer